// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__nt0O-","footer":"styles_footer__3vzHu"};